/**
 * Motivos que a pessoa precisa ler quando a sessão a tira de onde estava ou recusa o que fez (padrão P-Q8:
 * nada que fecha ou impede uma tela fica sem motivo — o aviso pode vir depois da ação). Funções puras.
 */

export const MSG_SESSAO_EXPIRADA = 'Sua sessão expirou. Entre novamente para continuar.'
export const MSG_SEM_CONEXAO_SESSAO = 'Não foi possível confirmar a sua sessão porque o servidor não respondeu. Confira a conexão e entre novamente.'
export const MSG_CSRF = 'Sua sessão foi renovada por segurança. Repita a ação.'
export const MSG_TROCA_SENHA = 'Defina a sua senha antes de continuar.'
export const MSG_SEM_PERMISSAO = 'Seu perfil não permite esta ação. As suas permissões foram atualizadas; se precisar dela, peça ao administrador da clínica.'
export const MSG_ACESSO_NEGADO = 'Acesso negado para esta ação.'

/** Texto do aviso na tela de login quando o sistema leva a pessoa para lá (undefined = sem aviso). */
export function avisoDeSaida(erro) {
  const dados = erro?.response?.data
  if (dados?.codigo === 'PERFIL_BLOQUEADO' && dados.message) return dados.message
  if (!erro?.response) return MSG_SEM_CONEXAO_SESSAO
  if (erro.response.status === 401) return MSG_SESSAO_EXPIRADA
  return undefined
}

/** Mensagem para o 403 que as telas não explicam por conta própria. */
export function avisoDeAcessoNegado(erro) {
  const dados = erro?.response?.data || {}
  switch (dados.codigo) {
    case 'CSRF_INVALIDO':
      return MSG_CSRF
    case 'TROCA_SENHA_OBRIGATORIA':
      return MSG_TROCA_SENHA
    case 'SEM_PERMISSAO':
      return MSG_SEM_PERMISSAO
    default:
      return dados.message || MSG_ACESSO_NEGADO
  }
}

export const MSG_SESSAO_TROCADA_ORIENTACAO =
  'Recarregue para continuar com a sessão atual deste navegador. Para usar dois usuários ao mesmo tempo, abra um deles numa janela anônima.'

const descreverContexto = (s) => `empresa ${s?.empresaId || '?'}, filial ${s?.filialId || '?'}`
const nomeDe = (usuario) => usuario?.nome || usuario?.login || 'outro usuário'

/**
 * P-S10 (src/docs/sessao-trocada-entre-abas.md): motivo do bloqueio da aba quando outra aba do mesmo navegador
 * entrou com outro usuário ou trocou empresa/filial. `atual` = o que esta aba mostra; `nova` = sessão do navegador
 * agora (pode faltar quando só veio a recusa do back).
 */
export function mensagemSessaoTrocada({ atual, nova } = {}) {
  if (!nova?.usuario) {
    return 'A sessão deste navegador foi trocada em outra aba (outro usuário, empresa ou filial). Esta aba foi bloqueada e nada foi gravado.'
  }
  const mesmoUsuario = atual?.usuario?.id != null && String(atual.usuario.id) === String(nova.usuario.id)
  if (mesmoUsuario) {
    return `Em outra aba, a sua sessão passou para ${descreverContexto(nova)}. Esta aba (${descreverContexto(atual)}) foi bloqueada para nada ser gravado no lugar errado.`
  }
  return `Em outra aba deste navegador entrou ${nomeDe(nova.usuario)}. Esta aba estava com ${nomeDe(atual?.usuario)} e foi bloqueada para nada ser gravado em nome de outra pessoa.`
}
